import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const ActionButtons = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/customer-dashboard/bookings')}
      className="w-full flex items-center justify-center gap-2 py-3 bg-primary text-white rounded-2xl text-sm font-bold"
    >
      <Icon name="CalendarCheck" size={16} />
      عرض حجوزاتي
    </button>
  );
};

export default ActionButtons;
